export function handleHideColumn(grid, props) {
	return (e) => {
		if (props.hideColumn) {
			e.sender.hideColumn(props.hideColumn);
		}
	};
}
